import { render, staticRenderFns } from "./KnowledgeBaseArchive.vue?vue&type=template&id=b95db26e&scoped=true"
import script from "./KnowledgeBaseArchive.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseArchive.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseArchive.vue?vue&type=style&index=0&id=b95db26e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95db26e",
  null
  
)

export default component.exports